import {
  ClientLoaderFunction,
  ClientLoaderFunctionArgs,
  redirect,
} from 'react-router';
import { FFOptions } from '@/feature-flags/flags.ts';
import { getFeatureFlags } from '@/feature-flags/get-feature-flags.ts';
import { paths } from '@/routes-utils/paths';
import { authInfoFromSession, sessionContext } from '@/session.ts';

export const featureFlagGuardLoader = <
  Args extends ClientLoaderFunctionArgs = ClientLoaderFunctionArgs,
  Data extends ReturnType<ClientLoaderFunction> = null,
>(
  fn: (args: Args) => Data = () => null as Data,
  {
    flag,
    redirectTo = paths.home,
  }: { flag: FFOptions | FFOptions[]; redirectTo?: string },
) => {
  async function flagProtectedLoader(args: Args) {
    const session = args.context.get(sessionContext);
    const authInfo =
      session.kind === 'guest' ? null : authInfoFromSession(session);
    const results = await Promise.all(
      (Array.isArray(flag) ? flag : [flag]).map((item) =>
        getFeatureFlags(item, authInfo),
      ),
    );

    return results.some(Boolean) ? fn(args) : redirect(redirectTo);
  }

  flagProtectedLoader.hydrate = true;

  return flagProtectedLoader;
};
